import {faDownload} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, List} from 'antd';
import {useMemo} from 'react';

import {Text} from '../../../../../../component/text/text';
import {useDomainConfig} from '../../../../../../provider/domain-config/domain-config-hook';
import {useDocumentationLinks} from '../../../../../../provider/help-links/help-links-hook';
import {ShortLocaleNameEnum} from '../../../../../../provider/locale/locale-context-type';
import {Locale} from '../../../../../../provider/locale/localization';
import {useUser} from '../../../../../../provider/user/user-hook';
import {CompaniesImportTypeEnum} from '../../../../../../service/companies-import/companies-import-type';
import {FeedResultsTypeEnum} from '../results/feed-results-const';

import * as styles from './template-links.scss';

type PropsType = {
    type: FeedResultsTypeEnum;
};

export function TemplateLinks(props: PropsType): JSX.Element | null {
    const {type} = props;
    const {feedTemplateLinks: baseLinks, feedTypeLabels} = useDomainConfig();

    const documentationLinks = useDocumentationLinks();
    const {user} = useUser();

    const userLanguage: ShortLocaleNameEnum = (user?.language as ShortLocaleNameEnum) || ShortLocaleNameEnum.en;

    const feedTemplateLinks = useMemo(() => {
        if (!feedTypeLabels) {
            return baseLinks;
        }

        const rocketdataCsvName = feedTypeLabels[CompaniesImportTypeEnum.RocketdataCsv];

        return baseLinks.map((link) => {
            if (link.name === rocketdataCsvName) {
                const fileName =
                    userLanguage === ShortLocaleNameEnum.ru ? 'rocketdata-example-ru.csv' : 'rocketdata-example-en.csv';

                return {
                    ...link,
                    link: `/static/feed-templates/${fileName}`,
                };
            }

            return link;
        });
    }, [baseLinks, feedTypeLabels, userLanguage]);

    const documentationLink = user
        ? type === FeedResultsTypeEnum.Validation
            ? documentationLinks.company.feedImportAndValidation
            : documentationLinks.company.feedImport
        : null;

    return (
        <>
            <List
                bordered
                className={styles.TemplateLinks}
                header={
                    <List.Item className={styles.TemplateLinks_header}>
                        <Text bolder stringKey="FEED__TEMPLATE_LINKS" />
                    </List.Item>
                }
            >
                {feedTemplateLinks.map(({name, link}) => (
                    <List.Item className={styles.TemplateLinks_item} key={name}>
                        <Text lighter>{name}</Text>

                        <a download href={link}>
                            <Button icon={<FontAwesomeIcon icon={faDownload} />} type="text" />
                        </a>
                    </List.Item>
                ))}
            </List>

            {documentationLink && (
                <Text
                    stringKey="FEED__TEMPLATE_LINKS__HELP"
                    valueMap={{
                        link: (
                            <a href={documentationLink} rel="noreferrer" target="_blank">
                                <Locale stringKey="FEED__TEMPLATE_LINKS__HELP_LINK" />
                            </a>
                        ),
                    }}
                />
            )}
        </>
    );
}
